import React from "react";

/**
 * Snowflake / droplet glyph — single colour, used in logo + favicon parity.
 * Default colour uses a slightly deeper, richer cyan (#2BA8C0) so the brand
 * mark feels premium next to the navy wordmark; the cyan elsewhere in the
 * palette (#4FC3D9) stays unchanged.
 */
export default function BrandGlyph({ size = 34, className = "", color = "#2BA8C0" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <g stroke={color} strokeWidth="2.1" strokeLinecap="round">
        <line x1="16" y1="4" x2="16" y2="28" />
        <line x1="6" y1="9.5" x2="26" y2="22.5" />
        <line x1="6" y1="22.5" x2="26" y2="9.5" />
        <polyline points="13,7 16,4 19,7" fill="none" />
        <polyline points="13,25 16,28 19,25" fill="none" />
        <polyline points="9,7 6,9.5 9,12" fill="none" />
        <polyline points="23,7 26,9.5 23,12" fill="none" />
        <polyline points="9,20 6,22.5 9,25" fill="none" />
        <polyline points="23,20 26,22.5 23,25" fill="none" />
      </g>
      <circle cx="16" cy="16" r="1.9" fill={color} />
    </svg>
  );
}

/**
 * Site logo lockup — bigger, more confident wordmark for the premium feel.
 * On mobile the "by Peptigen Labs" tagline is hidden so the larger logo +
 * hamburger sit comfortably at 390px width.
 */
export function Logo({ variant = "dark", showTagline = true }) {
  const wordmarkColor = variant === "dark" ? "text-navy" : "text-white";
  const taglineColor = variant === "dark" ? "text-muted" : "text-white/65";
  const glyphColor = variant === "dark" ? "#2BA8C0" : "#7CD9EA";
  return (
    <div className="flex items-center gap-3">
      <BrandGlyph color={glyphColor} />
      <div className="leading-none">
        <div
          className={`font-display font-bold tracking-tight text-[26px] sm:text-[28px] ${wordmarkColor}`}
        >
          PeptiChill
        </div>
        {showTagline && (
          <div
            className={`mt-1.5 hidden sm:block text-[12px] uppercase tracking-[0.2em] ${taglineColor}`}
          >
            by Peptigen Labs
          </div>
        )}
      </div>
    </div>
  );
}
